<template>
  <div class="col-12 col-md-6 col-lg-4  mb-4 mb-lg-0">
    <div class="card h-100">
      <div class="card-body">
        <h2 class="heading-card mb-3">{{ contact_us_title }}</h2>
        <ul class="row text-sm-start mb-4">
          <li class="col-6 col-md-12 mb-2" v-for="(link, index) in contact_us_links" v-bind:key="index"><i :class="link.icon"></i> <a :href="link.url">{{ link.title }}</a></li>
        </ul>

        <h2 class="heading-card mb-3">{{ social_media_title }}</h2>
        <ul class="social">
          <li v-for="(link, index) in social_media_links" v-bind:key="index"><a :href="link.url" :title="link.title"><i :class="link.icon"></i></a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    root: String
  },
  data () {
    return {
      contact_us_title: '',
      contact_us_links: '',
      social_media_title: '',
      social_media_links: []
    }
  },

  async created () {
    const { data: jsonData } = await axios.get(this.root + '/library/static/data/contacts.json?nocache' + (new Date()).getTime())
    this.contact_us_title = jsonData.contact_us.title
    this.contact_us_links = jsonData.contact_us.links
    this.social_media_title = jsonData.social.title
    this.social_media_links = jsonData.social.links
  }
}
</script>

<style scoped>
  ul {
    margin: 0 0 0 10px;
    padding: 0;
    list-style: none;
  }

  ul.social > li {
    display: inline;
    margin-right: 20px;
  }
</style>
